module.exports = __webpack_public_path__ + "static/hero_03-25bdb44ade3c2fa2db63c4659dbd89c5.jpg";